"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgRightIndent02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M20.531 1.5c-.388-.008-.691.163-.85.262-.165.1-.352.24-.533.377L15.23 5.077c-.125.093-.266.199-.379.3a1.52 1.52 0 0 0-.417.58 1.5 1.5 0 0 0 0 1.087c.11.28.293.467.417.579.113.101.254.207.379.3l3.917 2.938c.181.136.368.276.532.377.16.099.463.27.851.262a1.5 1.5 0 0 0 1.15-.575c.24-.306.284-.651.302-.838.017-.192.017-.425.017-.652v-5.87c0-.227 0-.46-.017-.652-.018-.187-.063-.532-.302-.838a1.5 1.5 0 0 0-1.15-.575ZM3 3a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2H3ZM3 8.25a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2H3ZM2 14.75a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 19a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z", fill: "currentColor" }) }))); };
exports.default = SvgRightIndent02;
